export function getOAuthParameter(
  search: string,
  name: "redirect_uri" | "state",
) {
  // Preserve repeated values and distinguish a bare key from an empty value,
  // matching the OAuth request shape previously produced by query-string.
  const values = search
    .replace(/^\?/, "")
    .split("&")
    .flatMap((entry) => {
      const value = new URLSearchParams(entry).get(name);
      if (value === null) {
        return [];
      }
      return [entry.includes("=") ? value : null];
    });

  if (values.length === 0) {
    return undefined;
  }
  return values.length === 1 ? values[0] : values;
}
